export const notificationSelector = state => state?.notifications?.get('results')?.toArray()
